/**
 * Observations Service
 * Observations management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentObservationDtoValueData } from './componentObservationDtoValueData';


export interface ComponentObservationDto { 
    /**
     * Component code
     */
    componentCode: string;
    /**
     * Component display name
     */
    componentDisplay: string;
    /**
     * Type of the component value
     */
    valueType?: ComponentObservationDto.ValueTypeEnum;
    valueData?: ComponentObservationDtoValueData;
    /**
     * Interpretation of the component
     */
    interpretation?: string;
    /**
     * Reference range for the component
     */
    referenceRange?: string;
}
export namespace ComponentObservationDto {
    export type ValueTypeEnum = 'quantity' | 'string' | 'boolean' | 'integer' | 'time' | 'dateTime' | 'period' | 'range' | 'ratio';
    export const ValueTypeEnum = {
        Quantity: 'quantity' as ValueTypeEnum,
        String: 'string' as ValueTypeEnum,
        Boolean: 'boolean' as ValueTypeEnum,
        Integer: 'integer' as ValueTypeEnum,
        Time: 'time' as ValueTypeEnum,
        DateTime: 'dateTime' as ValueTypeEnum,
        Period: 'period' as ValueTypeEnum,
        Range: 'range' as ValueTypeEnum,
        Ratio: 'ratio' as ValueTypeEnum
    };
}


